import { forwardRef, useImperativeHandle } from "react";
import {
  ModalStyle,
  ModalMain,
  ModalButtonCloseDiv,
  ModalTitle,
  ModalButtonClose,
  ModalContainer,
} from "./ModalStyled.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";

interface Props {
  children?: any;
  title: string;
  dontShowCloseButton?: boolean;
  modalFitContent: boolean;
  show: boolean;
  handleClose: () => void;
}

const Modal = forwardRef(
  (
    {
      title,
      handleClose,
      show,
      modalFitContent,
      dontShowCloseButton,
      children,
    }: Props,
    Ref
  ) => {
    useImperativeHandle(Ref, () => ({}));

    return (
      <ModalStyle style={{ display: show ? "block" : "none" }}>
        <ModalMain style={{ height: modalFitContent || "80%" }}>
          <ModalButtonCloseDiv>
            <ModalTitle>{title}</ModalTitle>
            {!dontShowCloseButton && (
              <ModalButtonClose onClick={handleClose}>
                <FontAwesomeIcon icon={faTimesCircle} />
              </ModalButtonClose>
            )}
          </ModalButtonCloseDiv>
          <ModalContainer
            style={{ height: modalFitContent || "calc(100% - 48px)" }}
          >
            {children}
          </ModalContainer>
        </ModalMain>
      </ModalStyle>
    );
  }
);

export default Modal;
